import axios from "axios";
import { URL_BASE } from "@/configs/constants";

const RESOURCE = 'client';
export default {

    loadClients(context, params) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, { params })
                .then(response => {
                    context.commit('LOAD_CLIENTS', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                    return reject(errors)
                })
        })
    },

    storeClient(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}${RESOURCE}`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => { })
        })
    },

    loadClient(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                .then(response => resolve(response.data))
                .catch((e) => reject(e))
        })
    },

    updateClient(context, formData) {
        return new Promise((resolve, reject) => {
            axios.put(`${URL_BASE}${RESOURCE}/${formData.id}`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => context.commit('PRELOADER', false))
        })
    },

    searchCNPJ(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}client-exist`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(()=> {
                    errors => reject(errors)
                })

        })
    },

    searchCPF(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}client-exist`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
        })
    },

    updateClientPhoto(context, formData) {
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        return new Promise((resolve, reject) => {

            axios.post(`${URL_BASE}client-photo`, formData, config)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => { })
        })
    }

}